import {
  fidelidadeSchema,
  ocupacaoSchema,
  performanceSchema,
  produtividadeSchema,
  resumoDashboardSchema,
  resultadoColetaMetricasSchema,
  type Fidelidade,
  type Ocupacao,
  type Performance,
  type PeriodoDashboard,
  type Produtividade,
  type ResumoDashboard,
  type ResultadoColetaMetricas,
} from "@base/contracts";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

export type DashboardGateway = {
  obterProdutividade(periodo: PeriodoDashboard): Promise<Produtividade>;
  obterOcupacao(periodo: PeriodoDashboard): Promise<Ocupacao>;
  obterPerformance(de: string, ate: string): Promise<Performance>;
  obterFidelidade(mes: string): Promise<Fidelidade>;
  obterResumo(opcoes?: {
    readonly periodo?: PeriodoDashboard;
    readonly mes?: string;
  }): Promise<ResumoDashboard>;
  coletarMetricas(): Promise<ResultadoColetaMetricas>;
};

export class DashboardGatewayHttp implements DashboardGateway {
  constructor(private readonly http: ClienteHttp) {}

  obterProdutividade(periodo: PeriodoDashboard): Promise<Produtividade> {
    return this.http.requisitar(
      "/v1/dashboard/produtividade",
      produtividadeSchema,
      { consulta: { periodo } },
    );
  }

  obterOcupacao(periodo: PeriodoDashboard): Promise<Ocupacao> {
    return this.http.requisitar("/v1/dashboard/ocupacao", ocupacaoSchema, {
      consulta: { periodo },
    });
  }

  obterPerformance(de: string, ate: string): Promise<Performance> {
    return this.http.requisitar("/v1/dashboard/performance", performanceSchema, {
      consulta: { de, ate },
    });
  }

  obterFidelidade(mes: string): Promise<Fidelidade> {
    return this.http.requisitar("/v1/dashboard/fidelidade", fidelidadeSchema, {
      consulta: { mes },
    });
  }

  obterResumo(opcoes?: {
    readonly periodo?: PeriodoDashboard;
    readonly mes?: string;
  }): Promise<ResumoDashboard> {
    return this.http.requisitar("/v1/dashboard/resumo", resumoDashboardSchema, {
      consulta: {
        ...(opcoes?.periodo ? { periodo: opcoes.periodo } : {}),
        ...(opcoes?.mes ? { mes: opcoes.mes } : {}),
      },
    });
  }

  coletarMetricas(): Promise<ResultadoColetaMetricas> {
    return this.http.requisitar(
      "/v1/dashboard/metricas/coletar",
      resultadoColetaMetricasSchema,
      { metodo: "POST", corpo: {} },
    );
  }
}
